exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-img-wrapper[data-v-12913703]{width:250px}.is-out-of-stock[data-v-12913703]{pointer-events:none}.relative[data-v-12913703]{position:relative}.outof-stock-overlay[data-v-12913703]{position:absolute;width:100%;height:100%;left:0;top:0}.button.is-warning[data-v-12913703],.button.is-warning[data-v-12913703] :hover{background-color:#f4716e;border-color:transparent;color:#fff;pointer-events:none}", ""]);

// exports
